import React from 'react'

export function NextArrow( props ) {
	const { className, style, onClick } = props;
	return (
		<div className="arrow next-arrow" onClick={onClick} />
	)
}

export function PrevArrow( props ) {
	const { className, style, onClick } = props;
	return (
		<div className="arrow prev-arrow" onClick={onClick} />
	)
}



// WEBPACK FOOTER //
// ./src/components/arrows.js